import { render, staticRenderFns } from "./UpcomingFixturesTableMyOdds.vue?vue&type=template&id=483736b6&"
import script from "./UpcomingFixturesTableMyOdds.vue?vue&type=script&lang=js&"
export * from "./UpcomingFixturesTableMyOdds.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports